(function () {
  const root = document.querySelector('[data-sbc-root]');
  if (!root) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const rail = root.querySelector('[data-sbc-rail]');
  const searchWrap = root.querySelector('[data-sbc-search-wrap]');
  const searchInput = root.querySelector('[data-sbc-search]');
  const searchClear = root.querySelector('[data-sbc-search-clear]');
  const noResult = root.querySelector('[data-sbc-noresult]');
  const catCountEl = root.querySelector('[data-sbc-cat-count]');
  const subCountEl = root.querySelector('[data-sbc-sub-count]');

  const cats = [...root.querySelectorAll('[data-sbc-cat]')];
  const railItems = rail ? [...rail.querySelectorAll('[data-sbc-rail-item]')] : [];

  if (reduced) {
    cats.forEach((c) => c.classList.add('in'));
  } else {
    const rev = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in');
            rev.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -6% 0px' }
    );
    cats.forEach((c) => rev.observe(c));
  }

  if (rail && railItems.length) {
    railItems.forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = document.getElementById(btn.dataset.target);
        if (target) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    });

    const spy = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          railItems.forEach((r) => r.classList.toggle('active', r.dataset.target === entry.target.id));
          const active = rail.querySelector('.rail__item.active');
          if (active && window.innerWidth <= 980) {
            active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
          }
        });
      },
      { rootMargin: '-130px 0px -68% 0px', threshold: 0 }
    );
    cats.forEach((c) => spy.observe(c));
  }

  const esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  function updateCounts() {
    const visibleCats = cats.filter((c) => !c.classList.contains('hide'));
    let subs = 0;
    visibleCats.forEach((cat) => {
      subs += cat.querySelectorAll('.sub:not(.hide)').length;
    });
    if (catCountEl) catCountEl.textContent = String(visibleCats.length);
    if (subCountEl) subCountEl.textContent = String(subs);
  }

  function filter() {
    if (!searchInput) return;
    const q = searchInput.value.trim().toLowerCase();
    if (searchWrap) searchWrap.classList.toggle('has-val', q.length > 0);

    let anyCat = false;
    cats.forEach((cat) => {
      let anySub = false;
      cat.querySelectorAll('.sub').forEach((sub) => {
        const name = sub.dataset.name || '';
        const nameEl = sub.querySelector('.sub__name');
        const orig = sub.dataset.label || nameEl.textContent;
        const match = !q || name.includes(q);
        sub.classList.toggle('hide', !match);
        if (match) anySub = true;
        if (q && match) {
          nameEl.innerHTML = orig.replace(new RegExp('(' + esc(q) + ')', 'ig'), '<mark>$1</mark>');
        } else {
          nameEl.textContent = orig;
        }
      });
      cat.classList.toggle('hide', !anySub);
      const railItem = rail ? rail.querySelector('[data-sbc-rail-item][data-target="' + cat.id + '"]') : null;
      if (railItem) railItem.classList.toggle('hide', !anySub);
      if (anySub) anyCat = true;
    });

    if (noResult) noResult.classList.toggle('show', !anyCat);
    updateCounts();
  }

  if (searchInput) {
    searchInput.addEventListener('input', filter);
    updateCounts();
  }
  if (searchClear && searchInput) {
    searchClear.addEventListener('click', () => {
      searchInput.value = '';
      filter();
      searchInput.focus();
    });
  }
})();
